// (c) Cognisoft Aps, 2022 

// objects as pseudo-enums

export const Role = {
  Super: "super",
  Admin: "admin",
  SLT: "slt",
  PWA: "pwa",
  Private: "private"
} as const;

export type Role = typeof Role[keyof typeof Role];

export const DocType = {
  Users: "users",
  Centers: "centers",
  Results: "results"
} as const;

export type DocType = typeof DocType[keyof typeof DocType];

export const Level = {
  First: "first",
  Second: "second",
  SecondVerb: "secondVerb",
  SecondSubject: "secondSubject"
} as const;

export type Level = typeof Level[keyof typeof Level];

// implicit routing for SPA, pages are components
export const Pages = {
  Login: "Login",
  AdminStart: "AdminStart",
  PrivateEdit: "PrivateEdit",
  CenterEdit: "CenterEdit",
  PWAEdit: "PWAEdit",
  SLTEdit: "SLTEdit",
  ResultList: "ResultList",
  ResultDetails: "ResultDetails",
  ResultsLineChart: "ResultsLineChart",
  ResultCsvData: "ResultCsvData",
  Ready: "Ready",
  Step1: "Step1",
  Step2: "Step2",
  Step3: "Step3",
  Step4: "Step4",
  Step5: "Step5",
  Step6: "Step6",
  Step7: "Step7",
  Step8: "Step8",
  Step8Verbs: "Step8Verbs",
  Step8Subject: "Step8Subject",
  Step9: "Step9",
  Step9Verbs: "Step9Verbs",
  Step9Subject: "Step9Subject",
  EndResults: "EndResults",
  Settings: "Settings"
} as const;

export type Pages = typeof Pages[keyof typeof Pages];

// state used on all task steps
//   tells whether image buttons should be disabled etc.
export const State = {
  WaitToStart: "waitToStart",
  PlayIntro: "playIntro",
  PresentTask: "presentTask",
  WaitForResponse: "waitForResponse",
  GivingHelp: "givingHelp",
  RepeatingSound: "repeatingSound",
  RepeatingTask: "repeatingTask",
  Error: "error",
  Correct: "correct",
  Paused: "paused",
  ExitModalShown: "exitModalShown",
  WaitAfterEnd: "waitAfterEnd"
} as const;

export type State = typeof State[keyof typeof State];


// to know if level 8 and 9 should use object, verb or subject with extended levels
export const LevelExtension = {
  Object: "object",
  Verb: "verb",
  Subject: "subject"
} as const;

export type LevelExtension = typeof LevelExtension[keyof typeof LevelExtension];

// used for task item

export const Vowels = {
  A: "a",
  E: "e",
  I: "i",
  O: "o",
  U: "u",
  Y: "y",
  Æ: "æ",
  Ø: "ø",
  Å: "å"
} as const;

export type Vowels = typeof Vowels[keyof typeof Vowels];

//   data definition of task items

export const Gender = {
  Male: "han",
  Female: "hun"
} as const;

export type Gender = typeof Gender[keyof typeof Gender];

// other enums

export const SvgColor = {
  DisabledColor: "#808080",
  EnabledColor: "#000000"
} as const;

export type SvgColor = typeof SvgColor[keyof typeof SvgColor];

// paths

export const Path = {
  Snd: "snd/",
  Img: "img/",
  ImgBg: "img-bg/"
} as const;

export type Path = typeof Path[keyof typeof Path];

export const Extension = {
  ImgBg: " bg.jpg",
  Png: ".png",
  Mp3: ".mp3",
  Webp: ".webp",
  WebpBg: " bg.webp"
} as const;

export type Extension = typeof Extension[keyof typeof Extension];

// button enums

export const IconButtonType = {
  Button: "button",
  Submit: "submit"
} as const;

export type IconButtonType = typeof IconButtonType[keyof typeof IconButtonType];

// Modal

export namespace ModalCss {
  export const Size = {
    Small: "small",
    Large: "large",
    XLarge: "xlarge"
  } as const;

  export type Size = typeof Size[keyof typeof Size];
}

// keyboard key codes

export const KeyboardKey = {
  ArrowLeft: "ArrowLeft",
  ArrowRight: "ArrowRight",
  Backspace: "Backspace",
  Enter: "Enter",
  Escape: "Escape"
} as const;

export type KeyboardKey = typeof KeyboardKey[keyof typeof KeyboardKey];

// message sound names for Danish language:

export const DaDK = {
  Ready: "er du klar",
  HandMe: "handme",
  ListenAgain: "listenagain",
  PointTo: "pointto",
  ReadAgain: "readagain",
  SayWordTogether: "saywordtogether",
  SaySentenceTogether: "saysentencetogether",
  ShowMe: "showme",
  Step1Intro: "step1intro",
  Step2Intro: "step2intro",
  Step3Intro: "step3intro",
  Step4Intro: "step4intro",
  Step4LeaveLastPicture: "step4leavelastpicture",
  Step5Intro: "step5intro",
  Step5ObsMove: "step5obsmove",
  Step6Intro: "step6intro",
  Step6FoundVowel: "step6foundvowel",
  Step7Intro: "step7intro",
  Step8IntroVerb: "step8introverb",
  Step8IntroSubject: "step8introsubject",
  Step9Intro: "step9intro",
  Step9IntroObject: "step9introobject",
  Step9IntroVerb: "step9introverb",
  Step9IntroSubject: "step9introsubject",
  Step1Help: "step1help",

  Step2Help: "step2help",

  Step3Help: "step3help",

  Step4Help: "step4help",

  Step5Help: "step5help",

  Step6Help: "step6help",

  Step7Help: "step7help",

  Step8Help: "step8help",

  Step9Help: "step9help",
  Step9HelpSubject: "step9helpsubject",

  TryAgain: "tryagain",
  Write: "write",
  AndNowOneMoreTime: "andnowonemoretime",
  AreYouSatisfied: "er du tilfreds",
  He_: "han_",
  She_: "hun_"
} as const;

export type DaDK = typeof DaDK[keyof typeof DaDK];
